module.exports = __webpack_public_path__ + "img/ins.bbb148ef.gif";